import { WorkplaceInCoworkingType } from 'shared/enums/WorkplaceInCoworkingType';

export function getPlaceTooltipText(type: WorkplaceInCoworkingType): string {
  switch (type) {
    case WorkplaceInCoworkingType.FixedWorkplace:
      return 'Этим рабочим столом будете пользоваться только вы';

    case WorkplaceInCoworkingType.FlexibleWorkplace:
      return 'Любое доступное рабочее место в зоне общего пользования коворкинга';

    default:
      throw new Error(`getPlaceTooltipText поле ${type} в енаме WorkplaceInCoworkingType не объявлено`);
  }
}
